export const CHANNEL_LABELS: Record<string, string> = {
  direct: 'Direct',
  facebook: 'Facebook',
  google: 'Google',
  google_my_business: 'Google My Business',
  gpt: 'GPT',
  instagram: 'Instagram',
  my_choice: 'My Choice',
  organic: 'Organic',
  other: 'Other',
};

// Chakra token strings (resolve correctly in dark mode)
export const CHANNEL_COLORS: Record<string, string> = {
  direct: 'purple.500',
  facebook: 'blue.500',
  google: 'red.500',
  google_my_business: 'pink.500',
  gpt: 'green.500',
  instagram: 'orange.400',
  my_choice: 'yellow.500',
  organic: 'teal.500',
  other: 'gray.400',
};

// Hex equivalents for contexts that need raw CSS colours (e.g. SVG bar charts)
export const CHANNEL_COLORS_HEX: Record<string, string> = {
  direct: '#805AD5',
  facebook: '#3182CE',
  google: '#E53E3E',
  google_my_business: '#D53F8C',
  gpt: '#38A169',
  instagram: '#DD6B20',
  my_choice: '#D69E2E',
  organic: '#319795',
  other: '#718096',
};
